import Comments from "./Container"

export default Comments
